<template>
  <span v-if="value >= 0" class="rating-block">
    <span class="rating-star" v-if="value > 0"><img src="/vue-app/assets/img/star.svg"></span>
    <span class="rating-star" v-else><img src="/vue-app/assets/img/star-empty.svg"></span>
    <span class="rating-star" v-if="value > 1"><img src="/vue-app/assets/img/star.svg"></span>
    <span class="rating-star" v-else><img src="/vue-app/assets/img/star-empty.svg"></span>
    <span class="rating-star" v-if="value > 2"><img src="/vue-app/assets/img/star.svg"></span>
    <span class="rating-star" v-else><img src="/vue-app/assets/img/star-empty.svg"></span>
    <span class="rating-star" v-if="value > 3"><img src="/vue-app/assets/img/star.svg"></span>
    <span class="rating-star" v-else><img src="/vue-app/assets/img/star-empty.svg"></span>
    <span class="rating-star" v-if="value > 4"><img src="/vue-app/assets/img/star.svg"></span>
    <span class="rating-star" v-else><img src="/vue-app/assets/img/star-empty.svg"></span>
  </span>
</template>

<script>
  export default {
    name: "rating",
    props: {
      value: null,
      ratingHeight: null,
      ratingColor: null
    },
    watch: {
    },
    mounted() {
      this.imgToSVG();
      this.setHeight();
      this.setColor();
    },
    methods: {
      setHeight() {
        if(!this.ratingHeight) this.ratingHeight = 10;
        $('.rating-star img').height(this.ratingHeight);
      },
      setColor() {
        $('.rating-star img').css("fill", this.ratingColor);
      },
      imgToSVG() {
        $('img.svg').each(function(){
          var $img = $(this);
          var imgID = $img.attr('id');
          var imgClass = $img.attr('class');
          var imgURL = $img.attr('src');

          $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass+' replaced-svg');
            }
            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');
            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
              $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }
            // Replace image with new SVG
            $img.replaceWith($svg);
          }, 'xml');
        });
      }
    }
  }
</script>
<style lang="scss">
  .rating-block {
    direction: ltr;
    letter-spacing: 0;
    color: inherit;
    position: absolute;
    margin: 0 10px;
  }
  .rating-block {
    display: block;
    position: relative;
  }
  .rating-star img {
    display: inline-block;
  }
</style>
